import BaseSurveyDialog from './BaseSurveyDialog'

/**
 * Survey Dialog
 * Wrapper around BaseSurveyDialog for backward compatibility
 * Handles survey metadata create and edit operations
 */
export default function SurveyDialog({
  isEdit = false,
  open = false,
  toggleOpen,
  handleSubmit,
  toggleDraft,
}) {
  const onSubmit = (data) => {
    handleSubmit(data)
    toggleDraft?.(true)
  }

  return (
    <BaseSurveyDialog
      isEdit={isEdit}
      open={open}
      toggleOpen={toggleOpen}
      handleSubmit={onSubmit}
      title={isEdit ? 'Edit Survey' : 'Create Survey'}
    />
  )
}
